/* eslint-disable no-return-assign */
import { Flex, Grid, Text, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { ModalBase } from '../../../../../components/ModalBase'
import { appApi, urlApi } from '../../../../../services/appApi'
import { ObterToken, PropInvalida } from '../../../../../Utils/Helper'
import { ModalBody } from './styles'
import { useState } from 'react'

interface iModal {
  isOpen: boolean
  onRequestClose: () => void
  reload: () => void
  tituloEixoX: string
  tituloEixoY: string
}

export const ModalCadastroEmMassa: React.FC<iModal> = ({ onRequestClose, reload, isOpen, tituloEixoX, tituloEixoY }) => {
  const toast = useToast()
  const [Erros, setErros] = useState<string[]>([])
  const [Arquivo, setArquivo] = useState<FormData>()
  const [Nome, setNome] = useState('')
  const [SubirDesempenho, setSubirDesempenho] = useState(true)
  const [SubirPotencial, setSubirPotencial] = useState(true)
  const AtualizarArquivo = (arquivo: any): void => {
    const formdata = new FormData()
    formdata.append('arquivo', arquivo.target.files[0])
    setArquivo(formdata)
    setNome(arquivo.target.files[0].name)
    toast({
      title: 'Arquivo selecionado com sucesso!',
      status: 'success',
      isClosable: false,
      position: 'top-right',
      duration: 4000
    })
  }

  function AlterarEixo(eixo: 'desempenho' | 'potencial', marcado: boolean): void {
    if (!marcado && !(eixo === 'desempenho' ? SubirPotencial : SubirDesempenho)) {
      toast({
        title: 'Um dos dois eixos deve estar marcado',
        status: 'warning',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    setErros([])
    if (eixo === 'desempenho') {
      setSubirDesempenho(marcado)
    } else {
      setSubirPotencial(marcado)
    }
  }

  function EnviarEmMassa(): void {
    appApi.post(`NineBox/Csv?desempenho=${SubirDesempenho.toString()}&potencial=${SubirPotencial.toString()}`, Arquivo)
      .then(res => {
        toast({
          title: 'Colaboradores avaliados com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        reload()
        if (res.data.length > 0) {
          setErros(res.data)
        } else {
          onRequestClose()
        }
      })
      .catch(({ response }) => {
        toast({
          title: response?.data ?? 'Não foi possível enviar o arquivo',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 6000
        })
      })
  }

  return (
    <ModalBase
      Titulo='Avaliar colaboradores em massa'
      isOpen={isOpen}
      onClose={onRequestClose}
      Width='65rem'
    >
      <ModalBody style={{ fontSize: '.875rem' }}>
        <span><strong>Instruções para gerar o arquivo no excel: </strong>
          Baixe o arquivo de exemplo e preencha com os dados abaixo da linha de título.
          Após isso, clique em "Salvar como..." e selecione o formato
          <b> CSV UTF-8 (Delimitado por vírgulas). </b>
           As colunas que estão marcadas com “*” são campos obrigatórios.
          Por favor, realize o preenchimento completo para correto envio.
          <small> Obrigatório a inserção do endereço de email</small>
        </span>

        <Flex flexDir={'column'} width={'100%'} gap={'.25rem'} mt={'.75rem'}>
          <Text fontWeight={'700'}>Notas que a planilha traz</Text>
          <Flex gap={'1.5rem'}>
            <CheckboxCmp
              isChecked={SubirDesempenho}
              OnChange={(e) => AlterarEixo('desempenho', e)}
            >{tituloEixoX}</CheckboxCmp>
            <CheckboxCmp
              isChecked={SubirPotencial}
              OnChange={(e) => AlterarEixo('potencial', e)}
            >{tituloEixoY}</CheckboxCmp>
          </Flex>
          {(!SubirDesempenho || !SubirPotencial) &&
            <Text fontSize={'.813rem'} color={'var(--Gray2)'}>
              O eixo desmarcado não é lido: a nota atual de cada colaborador nele é mantida.
            </Text>
          }
        </Flex>

        <label style={{ borderRadius: '.25rem', height: '1.95rem', fontSize: '.875rem', padding: '.25rem .75rem' }} htmlFor='Ifile'>{Arquivo ? Nome : 'Selecione um arquivo'}</label>
        <input onChange={(e) => AtualizarArquivo(e)} id='Ifile' type={'file'} />
        {Erros?.length > 0 &&
        <Flex flexDir={'column'} width={'100%'} border={'2px solid var(--Red)'} borderRadius='.25rem' mt={'.75rem'} as={'ul'} padding='1rem 1rem 1rem 2rem'>
          <Text textAlign={'center'} fontWeight='bold' mb={'1rem'} fontSize={'.875rem'}>Linhas que não foram avaliadas</Text>
          <Grid templateColumns='repeat(2, 1fr)' gap={3}>
            {Erros?.map((e) => {
              return (
                <li style={{ fontSize: '.813rem' }}>{e}</li>
              )
            })}
          </Grid>
        </Flex>}
      </ModalBody>
      <Flex justifyContent={'end'} padding='1rem' gap={'.5rem'}>
        <ButtonCmp
          onClick={() => window.location.href = `${urlApi}/NineBox/Csv?token=${ObterToken()}&desempenho=${SubirDesempenho.toString()}&potencial=${SubirPotencial.toString()}`}
          VarColor='Rosa'
        >Baixar modelo da planilha{!SubirPotencial ? ` ${tituloEixoX}` : ''}{!SubirDesempenho ? ` ${tituloEixoY}` : ''}</ButtonCmp>
        <ButtonCmp isDisabled={PropInvalida(Arquivo)} onClick={EnviarEmMassa} VarColor='Green2' size='md'>Enviar arquivo</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
